import React, { useContext } from "react";
import { Clock, History, LogOut } from "lucide-react";
import { TenantContext } from "../../contexts/TenantContext";
import { SCURO } from "../integrations/casella";

/** "dalle 10:20" oggi, altrimenti "dal 3 nov, 10:20". */
function daQuando(iso) {
  const da = new Date(iso);
  if (Number.isNaN(da.getTime())) return null;
  const ora = da.toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" });
  const oggi = da.toDateString() === new Date().toDateString();
  return oggi ? `dalle ${ora}` : `dal ${da.toLocaleDateString("it-IT", { day: "numeric", month: "short" })}, ${ora}`;
}

/**
 * In cima a tutte le pagine, ferma mentre si scorre, finche' un
 * amministratore di sistema lavora nell'organizzazione di un cliente come
 * PingUp (lib/passPingup.js): per chi, da quando, che le modifiche si
 * annotano, e come uscire. Gli stessi pezzi della scheda di un invito
 * (PendingInvitations): fondo bianco, testi nei grigi della dashboard,
 * pulsante scuro. Fuori dal pass non disegna niente.
 */
export default function BarraPassPingup() {
  const tenant = useContext(TenantContext);
  const pass = tenant?.pass;
  if (!pass) return null;

  const quando = daQuando(pass.da);
  const cliente = [pass.cliente?.nome, pass.cliente?.email].filter(Boolean).join(" · ");

  return (
    <div
      role="status"
      aria-label={`Stai lavorando come PingUp per ${pass.tenant.name}`}
      className="sticky top-0 z-40 border-b border-[#E2E8F0] bg-white shadow-[0_1px_2px_rgba(15,23,42,0.04)]"
    >
      <div className="flex flex-wrap items-center gap-x-4 gap-y-2 px-4 py-2.5">
        <div className="min-w-[12rem] flex-1 leading-tight">
          <p className="truncate text-sm font-semibold text-[#020617]">Stai lavorando come PingUp per {pass.tenant.name}</p>
          <p className="mt-0.5 flex flex-wrap items-center gap-x-3 gap-y-0.5 text-xs text-[#94A3B8]">
            {cliente ? <span className="truncate text-[#64748B]">{cliente}</span> : null}
            {quando ? (
              <span className="inline-flex items-center gap-1.5">
                <Clock className="h-3.5 w-3.5" aria-hidden="true" />
                Dentro {quando}
              </span>
            ) : null}
            <span className="inline-flex items-center gap-1.5">
              <History className="h-3.5 w-3.5" aria-hidden="true" />
              Ogni modifica viene annotata
            </span>
          </p>
        </div>
        <button type="button" onClick={tenant.esciDalPass} className={`${SCURO} shrink-0`}>
          <LogOut className="h-3.5 w-3.5" aria-hidden="true" />
          Esci e torna a Clienti
        </button>
      </div>
    </div>
  );
}
